import { type } from "os";

export interface Activity {
  id: string;
  name: string;
  description: string; // Adding this field that's referenced in the component
}

// Create a schema representation of the interface
export const ActivitySchema = {
  name: 'Activity',
  nameAttribute: 'name',
  idType: 'string',
  properties: {
    id: { type: 'string' },
    name: { type: 'string' },
    activity_type: { type: 'string' },
    periodicity: { type: 'string' },
    calendar_type: { type: 'string' }
  }
};
